import styles from "./index.module.css";
import TitleBlock from "./TitleBlock";
import Footer from "../../Components/Footer";
import Form from "./Form";
import Topics from "./Topics";
import { useContext, useEffect } from "react";
import UserContext from "../../store/UserStore/context";
import { useNavigate } from "react-router-dom";
import TeachersBlock from "./TeachersBlock";
import getLevelInfo from "./helpers";

export default function IntesivePage() {
  const context = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!context.store.user || !context.store.user.testResult)
      return navigate("/");
    const score = context.store.user.testResult;
    const { key } = getLevelInfo(score);
    const closed = false;
    if (closed) {
      return navigate("/");
    }
  }, []);
  if (!context.store.user || !context.store.user.testResult) return null;
  const score = context.store.user.testResult;
  const { key } = getLevelInfo(score);
  const closed = false;
  if (closed) {
    return null;
  }
  return (
    <div className={styles.container}>
      <TitleBlock />
      <TeachersBlock />
      <Topics />
      {context.store.user?.isPaid ? null : <Form key={key} />}
      <Footer noFIre />
    </div>
  );
}
